export const SPECIFIC_SKILL_TRANSITION_PERIOD_ERROR_MESSAGE = "「特定技能経過期間」は最大5年0か月までに設定してください。";
